import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CoinsService_GetCoinsHistoryHeaderLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.grpc.lazy';
import {useCustomerSession} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../ReductionsState/useReductionsStateRequestParameter';

export const useCoinsHistoryHeader = () => {
  const session = useCustomerSession();

  return useGrpcRequest(
    CoinsService_GetCoinsHistoryHeaderLazy,
    {
      reductionsState: useReductionsStateRequestParameter(),
      session: session!,
    },
    {
      disabled: !session,
      mockData: async () => {
        return import('../__mocks__/getCoinsHistoryMock').then(
          module => module.headerMock,
        );
      },
    },
  );
};
